import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useState } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import FilterByDate from "./FilterByDate";
import FilterByGenres from "./FilterByGenres";
import FilterByRating from "./FilterByRating";

const FilterBy = ({ currentTab, moviesGenres, tvGenres }) => {
  const [filter] = useAutoAnimate();
  const [openFilter, setOpenFilter] = useState(true);

  return (
    <div
      ref={filter}
      className="bg-dark-lighten rounded-md shadow-md px-4 pt-3 mt-4"
    >
      <div
        className="flex justify-between items-center text-white pb-3 cursor-pointer"
        onClick={() => setOpenFilter((prev) => !prev)}
      >
        <p className="text-lg">Filter</p>
        <button>
          {openFilter && <FiChevronDown size={20} />}
          {!openFilter && <FiChevronRight size={20} />}
        </button>
      </div>
      {openFilter && (
        <div className="py-2">
          <div className="mb-4 text-dark-darken rounded-full border-2 border-gray-darken">
            <p className="px-4 py-2 bg-white text-dark-darken rounded-full uppercase font-medium w-fit">
              Genres
            </p>
          </div>
          <FilterByGenres
            currentTab={currentTab}
            moviesGenres={moviesGenres}
            tvGenres={tvGenres}
          />
          <div className="mt-6 mb-4 text-dark-darken rounded-full border-2 border-gray-darken">
            <p className="px-4 py-2 bg-white text-dark-darken rounded-full uppercase font-medium w-fit">
              Runtime
            </p>
          </div>
          <FilterByRating />
          <div className="mt-6 mb-4 text-dark-darken rounded-full border-2 border-gray-darken">
            <p className="px-4 py-2 bg-white text-dark-darken rounded-full uppercase font-medium w-fit">
              Release Dates
            </p>
          </div>
          <FilterByDate />
        </div>
      )}
    </div>
  );
};

export default FilterBy;
